export var backgroundsStreamId = '@@BACKGROUNDS';
export var reduxKey = '@@BACKGROUNDS';
export var actionKey = '@@BACKGROUNDS';
export var streamType = '@@BACKGROUNDS';
export var DEFAULT_BACKGROUND_ID = -1;
//# sourceMappingURL=constants.js.map